import React, { useState } from "react";
import { Box, Container, Typography, Button } from "@mui/material";

export default function ChargingSpeed({ data, onBookNow, onLocateCharger }) {
  const [active, setActive] = useState(data.options[0].key);
  const option = data.options.find((o) => o.key === active) || data.options[0];

  return (
    <Box sx={{ py: { xs: 4, md: 6 }, px: 2 }}>
      <Container maxWidth="md">
        <Box
          sx={{
            backgroundColor: "#eef1f3",
            borderRadius: "8px",
            p: { xs: 3, md: 5 },
          }}
        >
          <Typography
            fontFamily="KIAbodyLatinbasic_Bold"
            textAlign="center"
            sx={{ fontSize: "clamp(22px, 3.5vw, 30px)", mb: 3 }}
          >
            {data.heading}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              gap: { xs: 3, sm: 4 },
            }}
          >
            <Box
              component="img"
              loading="lazy"
              decoding="async"
              src={data.image}
              alt="Charging"
              sx={{
                width: { xs: "100%", sm: "260px" },
                height: { xs: "180px", sm: "220px" },
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />

            <Box sx={{ flex: 1, width: "100%" }}>
              <Box sx={{ display: "flex", mb: 2, borderRadius: "24px", overflow: "hidden", width: "fit-content" }}>
                {data.options.map((o) => (
                  <Box
                    key={o.key}
                    onClick={() => setActive(o.key)}
                    sx={{
                      cursor: "pointer",
                      px: 2.5,
                      py: 1.2,
                      textAlign: "center",
                      backgroundColor: active === o.key ? "#05141f" : "#e2e5e7",
                      color: active === o.key ? "#fff" : "#000",
                      transition: "0.3s",
                    }}
                  >
                    <Typography fontFamily="KIAbodyLatinbasic_Bold" sx={{ fontSize: "13px" }}>
                      {o.label}
                    </Typography>
                    <Typography fontFamily="KIAbodyLatinbasic_Regular" sx={{ fontSize: "11px" }}>
                      {o.sub}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Box sx={{ backgroundColor: "#fff", p: 3, borderRadius: "4px", mb: 3 }}>
                <Typography fontFamily="KIAbodyLatinbasic_Bold" sx={{ fontSize: "18px" }}>
                  {option.headline}
                </Typography>
                <Typography fontFamily="KIAbodyLatinbasic_Regular" sx={{ fontSize: "14px", mt: 0.5 }}>
                  {option.note}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <Button
                  onClick={onBookNow}
                  variant="contained"
                  sx={{
                    backgroundColor: "#05141f",
                    borderRadius: "20px",
                    textTransform: "none",
                    px: 3,
                    "&:hover": { backgroundColor: "#000" },
                  }}
                >
                  Book Now
                </Button>
                <Button
                  onClick={onLocateCharger}
                  variant="contained"
                  sx={{
                    backgroundColor: "#05141f",
                    borderRadius: "20px",
                    textTransform: "none",
                    px: 3,
                    "&:hover": { backgroundColor: "#000" },
                  }}
                >
                  Locate a charger
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>

        {data.disclaimer && (
          <Typography
            variant="caption"
            color="text.secondary"
            fontFamily="KIAbodyLatinbasic_Regular"
            sx={{ display: "block", mt: 2, fontSize: "11px" }}
          >
            {data.disclaimer}
          </Typography>
        )}
      </Container>
    </Box>
  );
}
